import { defineMessages } from 'react-intl';

export const insureByRulesMessages = defineMessages({
  automationRulesDescription: {
    defaultMessage: 'You can manage all your automation rules on the <a>automations page</a>.',
    description: 'Description with link to automations page for insurance rule management',
    id: 'v8r0dh',
  },
  createInsuranceRule: {
    defaultMessage: 'Create Insurance Rule',
    description: 'Link to create an insurance automation rule',
    id: 'wBqBa4',
  },
  activeRulesBanner: {
    defaultMessage: 'You have one or more rules tied to insurance that are currently active. <a>View Rules</a>',
    description: 'Success banner when insurance automation rules are active with link to view rules',
    id: 'mXVIJQ',
  },
  validationError: {
    defaultMessage: "An insurance rule is required. Create one by clicking 'Create Insurance Rule' above.",
    description: 'Error message when user tries to save without creating an insurance rule',
    id: 'Y+LTTD',
  },
});
